/*
 * @Author: your name
 * @Date: 2021-12-16 10:40:51
 * @LastEditTime: 2021-12-16 10:52:40
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \exchange-platform\src\utils\config.js
 */
const base_url = 'https://qianyao.duokakeji.cn/'

export default base_url